module.exports = __webpack_public_path__ + "static/media/Flare.a64a0f20.png";